var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[_c('HeaderCpt'),_c('v-main',{staticClass:"main fill-height"},[_c('v-container',{staticClass:"main-container",attrs:{"align-center":""}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }